// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__8NoYv","footerItem":"footer_footerItem__TL0aa","active":"footer_active__vkK-e"};